import gql from "graphql-tag";

import { metadataFragment } from "./metadata";
import { productFragment } from "./products";

export const categoryFragment = gql`
  fragment CategoryFragment on Category {
    id
    name
    children {
      totalCount
    }
    products {
      totalCount
    }
  }
`;
export const categoryDetailsFragment = gql`
  ${metadataFragment}
  ${productFragment}
  fragment CategoryDetailsFragment on Category {
    id
    ...MetadataFragment
    backgroundImage {
      alt
      url
    }
    name
    slug
    descriptionJson
    seoDescription
    seoTitle
    seoKeyword
    parent {
      id
    }
    recommendProducts(showDefault: true) {
      ...ProductFragment
    }
    alsoLikeProducts(showDefault: true) {
      ...ProductFragment
    }
    buyTogetherProducts(showDefault: true) {
      ...ProductFragment
    }
  }
`;
